// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"d5b44311","171":"d2ef5f7c","378":"a4645fac"}[chunkId] + ".chunk.js";
};